import { render } from "./AfiliadoBanner.vue?vue&type=template&id=87e6b1d6&scoped=true"
import script from "./AfiliadoBanner.vue?vue&type=script&lang=js"
export * from "./AfiliadoBanner.vue?vue&type=script&lang=js"

import "./AfiliadoBanner.vue?vue&type=style&index=0&id=87e6b1d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e6b1d6"]])

export default __exports__